import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";

import { CCard, CCardBody, CCol, CCollapse, CRow } from "@coreui/react";

import { usePermissionCheck } from "src/1/common/components/others";
import { history } from "src/App";
import { Magnifying, XCircleFill } from "src/common/assets/icons";
import {
  CButton,
  CDate,
  CInput,
  CSelect,
} from "src/common/components/controls";
import { CActionGroup } from "src/common/components/others";
import {
  COMBO_STATUSES_OPTIONS,
  ENTITY_GROUP_CODE,
  PERMISSION_VALUE,
} from "src/configs/constant";
import { Can } from "src/utils/ability";
import { useMobileDevice } from "src/utils/hooks/viewport";

export const ComboToolbar = ({
  params,
  canEdit,
  canRemove,
  onPause,
  onSearch,
  onEdit,
  onRemove,
}) => {
  //#region Data
  const { control, handleSubmit } = useForm({
    defaultValues: params,
  });

  const isMobile = useMobileDevice();

  const checkPermission = usePermissionCheck();
  //#endregion

  //#region Event
  const onClick = (state) => {
    switch (state) {
      case "add":
        return history.push("/combos/create");
      case "edit":
        return onEdit();
      case "remove":
        return onRemove();
      case "print":
      default:
        return;
    }
  };

  const search = handleSubmit((searchValues) => onSearch(searchValues));
  //#endregion

  //#region Render
  return (
    <CCard className={classNames("toolbar", !isMobile && "sticky")}>
      <CCardBody>
        <CRow>
          <CCol xs="12" className="action">
            <div>
              <CActionGroup
                onClick={onClick}
                canAdd={checkPermission({
                  [ENTITY_GROUP_CODE.COMBO]: PERMISSION_VALUE.CREATE,
                })}
                canEdit={
                  canEdit &&
                  checkPermission({
                    [ENTITY_GROUP_CODE.COMBO]: PERMISSION_VALUE.UPDATE,
                  })
                }
                canRemove={
                  canRemove &&
                  checkPermission({
                    [ENTITY_GROUP_CODE.COMBO]: PERMISSION_VALUE.DELETE,
                  })
                }
              />
            </div>
            <div>
              <Can do={PERMISSION_VALUE.APPROVE} on={ENTITY_GROUP_CODE.COMBO}>
                <CButton
                  disabled={!canEdit}
                  color="danger"
                  icon={<XCircleFill />}
                  onClick={onPause}
                  className="mr-0"
                >
                  Ngưng
                </CButton>
              </Can>
            </div>
          </CCol>
        </CRow>

        <CCollapse show>
          <div className="mt-3 flex flex-row flex-wrap gap-2">
            <div className="min-w-[200px]">
              <Controller
                control={control}
                name="status"
                render={({ field }) => (
                  <CSelect
                    {...field}
                    label="Trạng thái"
                    options={COMBO_STATUSES_OPTIONS}
                    select="value"
                    optionAll
                  />
                )}
              />
            </div>
            <div className="min-w-[240px]">
              <Controller
                control={control}
                name="code"
                render={({ field }) => (
                  <CInput
                    {...field}
                    label="Mã combo"
                    placeholder="Tìm kiếm theo mã"
                  />
                )}
              />
            </div>
            <div className="min-w-[240px]">
              <Controller
                control={control}
                name="name"
                render={({ field }) => (
                  <CInput
                    {...field}
                    label="Tên combo"
                    placeholder="Tìm kiếm theo tên"
                  />
                )}
              />
            </div>
            <div className="w-[200px]">
              <Controller
                control={control}
                name="start"
                render={({ field }) => <CDate {...field} label="Từ ngày" />}
              />
            </div>
            <div className="w-[200px]">
              <Controller
                control={control}
                name="end"
                render={({ field }) => <CDate {...field} label="Đến ngày" />}
              />
            </div>
            <div className="ml-auto btn-search">
              <div className="form-group flex flex-row gap-2 c-input">
                <CButton
                  icon={<Magnifying />}
                  onClick={search}
                  className="mr-0"
                >
                  Tìm kiếm
                </CButton>
              </div>
            </div>
          </div>
        </CCollapse>
      </CCardBody>
    </CCard>
  );
  //#endregion
};
